import React from 'react'
import Responsive, { MediaQueryProps } from 'react-responsive'
import { useMediaQuery } from '@material-ui/core'
import { theme } from '../../theme'

function Tablet(props: MediaQueryProps) {
  return (
    <Responsive
      {...props}
      minWidth={theme.breakpoints.mobile}
      maxWidth={theme.breakpoints.tablet}
    />
  )
}

export function useIsTablet(): boolean {
  const matches = useMediaQuery(`(max-width: ${theme.breakpoints.mobile})`)

  return matches
}

export default Tablet
